import type { ReactNode } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { ChartLine, Envelope, VideoCamera, type Icon as PhosphorIcon } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../components/auth/auth-heading';
import { TermsLinks } from '../../../../components/auth/terms-links';
import { Icon } from '../../../../components/Icon';
import { buttonClassName } from '../../../../components/ui/button';

export const Route = createFileRoute('/subdomain/app/_auth/welcome')({
  component: WelcomePage,
});

function ValueRow({ icon, title, children }: { icon: PhosphorIcon; title: string; children: ReactNode }) {
  return (
    <li className="flex items-center gap-(--mbm-space-3) rounded-(--mbm-radius-md) border border-border-line p-(--mbm-space-3)">
      <span className="flex size-(--mbm-size-icon-tile-large) shrink-0 items-center justify-center rounded-(--mbm-component-radius-icon-tile) bg-surface-tint text-text-primary">
        <Icon icon={icon} size="md" />
      </span>
      <span className="flex min-w-0 flex-col">
        <span className="text-label-medium text-text-primary">{title}</span>
        <span className="text-body-xsmall text-text-tertiary">{children}</span>
      </span>
    </li>
  );
}

function WelcomePage() {
  return (
    <>
      <AuthHeading
        title="Welcome to mybusinessmate"
        subtitle="Answer 5 quick questions and get a free health check of your website, Google profile and Instagram."
      />

      <ul className="flex flex-col gap-(--mbm-space-3)">
        <ValueRow icon={Envelope} title="New enquiry from Google">
          “Do you cater for 50 people?”
        </ValueRow>
        <ValueRow icon={VideoCamera} title="Your reel is ready">
          Approve or request changes
        </ValueRow>
        <ValueRow icon={ChartLine} title="Monthly report is in">
          Calls up 42% vs last month
        </ValueRow>
      </ul>

      <p className="text-label-medium text-text-secondary">Your mate runs the marketing. You run the business.</p>

      <div className="flex flex-col gap-(--mbm-space-3)">
        <Link to="/subdomain/app/onboarding/industry" className={buttonClassName({ fullWidth: true })}>
          Get started
        </Link>
        <Link to="/subdomain/app/sign-in" className={buttonClassName({ variant: 'secondary', fullWidth: true })}>
          I already have an account
        </Link>
      </div>

      <p className="text-body-xsmall text-text-tertiary">
        By continuing, you agree to our <TermsLinks />.
      </p>
    </>
  );
}
